import type { Voice } from "@/app/_data/voices";

export interface VoiceWithPreview extends Voice {
  description?: string;
  previewUrl: string;
  languages?: {
    language: string;
    previewUrl?: string | null;
  }[];
}

type VoicePreviewSource = Pick<VoiceWithPreview, "previewUrl" | "languages">;

/**
 * Get the appropriate preview URL for a voice, preferring language-specific preview URL if available
 */
export function getPreviewUrlForLanguage<T extends VoicePreviewSource>(voice: T, languageCode?: string): string {
  // Check if the voice has language-specific preview URLs and a language is selected
  if (languageCode && voice.languages && voice.languages.length > 0) {
    // Look for a language entry that matches the selected language
    const languageEntry = voice.languages.find(lang => lang.language === languageCode);
    if (languageEntry?.previewUrl) {
      return languageEntry.previewUrl;
    }
  }
  // Fall back to the default preview URL
  return voice.previewUrl;
}
